<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="device.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">IP-адрес устройства</label>
            <crm-input-text
              [(value)]="device.ipAddress"
              [isError]="$any(errors?.ipAddress)"></crm-input-text>
            <small
              *ngIf="errors?.ipAddress"
              class="p-error">
              {{ errors.ipAddress | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">OID значения с номером линии блокировки</label>
            <crm-input-text
              [(value)]="device.lockIndicatorOid"
              [isError]="$any(errors?.lockIndicatorOid)"></crm-input-text>
            <small
              *ngIf="errors?.lockIndicatorOid"
              class="p-error">
              {{ errors.lockIndicatorOid | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium">Номер линии блокировки, который надо прослушивать</label>
            <p-inputNumber
              [(ngModel)]="device.lockIndicatorNumber">
            </p-inputNumber>
            <small
              *ngIf="errors?.lockIndicatorNumber"
              class="p-error">
              {{ errors.lockIndicatorNumber | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">OID флага блокировки</label>
            <crm-input-text
              [(value)]="device.lockValueOid"
              [isError]="$any(errors?.lockValueOid)"></crm-input-text>
            <small
              *ngIf="errors?.lockValueOid"
              class="p-error">
              {{ errors.lockValueOid | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium">Значение флага блокировки, при котором устройство считается заблокированным</label>
            <p-inputNumber
              [(ngModel)]="device.lockValue">
            </p-inputNumber>
            <small
              *ngIf="errors?.lockValue"
              class="p-error">
              {{ errors.lockValue | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveDevice()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteDevice()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
